import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export function removeUndefinedOrNull(obj: any): any {
    if (obj === null || obj === undefined) {
        return undefined;
    }

    if (Array.isArray(obj)) {
        return obj.map(v => removeUndefinedOrNull(v)).filter(v => v !== undefined && v !== null);
    }

    if (typeof obj === 'object') {
        const newObj: any = {};
        Object.keys(obj).forEach(key => {
            const value = removeUndefinedOrNull(obj[key]);
            if (value !== undefined && value !== null) {
                newObj[key] = value;
            }
        });
        return newObj;
    }

    return obj;
}

const regions = [
    { Code: "ACT", Name: "Australian Capital Territory", CountryCode: "AUS" },
    { Code: "NSW", Name: "New South Wales", CountryCode: "AUS" },
    { Code: "NT", Name: "Northern Territory", CountryCode: "AUS" },
    { Code: "QLD", Name: "Queensland", CountryCode: "AUS" },
    { Code: "SA", Name: "South Australia", CountryCode: "AUS" },
    { Code: "TAS", Name: "Tasmania", CountryCode: "AUS" },
    { Code: "VIC", Name: "Victoria", CountryCode: "AUS" },
    { Code: "WA", Name: "Western Australia", CountryCode: "AUS" }
];

export function getCodeByName(name) {
    const lowercasedName = name?.trim()?.toLowerCase();
    const region = regions.find(region => 
        region?.Name?.toLowerCase() === lowercasedName || 
        region?.Code?.toLowerCase() === lowercasedName
    );
    return region ? region.Code : name;
}

export function formatDate(currentDate, timeZone, formatStr) {
    // Convert the date to the specified time zone
    const zonedDate = utcToZonedTime(currentDate, timeZone);

    // Format the zoned date
    return format(zonedDate, formatStr);
}
